//* Libraries imports
import { motion } from "framer-motion";
import "./criterios-zero-alert.scss";

//* Types imports
/**
 * Represents a criterion that received zero score
 */
interface CriterioZero {
  /** Unique identifier for the criterion */
  id: number;
  /** Display name of the criterion */
  name: string;
}

/**
 * Props for the CriteriosZeroAlert component
 */
interface CriteriosZeroAlertProps {
  /** Array of criteria that received zero score */
  criteriosZero: CriterioZero[];
}

/**
 * Component that displays criteria that caused the essay to receive zero score.
 * Uses warm orange colors and clear messaging to help students understand 
 * which specific criteria resulted in the essay being zeroed.
 * 
 * Features:
 * - Responsive grid layout
 * - Smooth animations with Framer Motion
 * - Full accessibility support
 * - Clear cause-effect messaging about essay zero score
 * - Encouraging tone for improvement
 * 
 * @param criteriosZero - Array of criteria that caused the essay to be zeroed
 * @returns JSX.Element or null if no criteria to display
 */

export function CriteriosZeroAlert({ criteriosZero }: CriteriosZeroAlertProps) {
  console.log(criteriosZero)
  if (!criteriosZero || criteriosZero.length === 0) {
    return null;
  }

  return (
    <motion.div 
      className="criterios-zero-section horizontal-layout"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.2 }}
      role="alert"
      aria-live="polite"
      aria-labelledby="criterios-zero-title"
    >
      <div className="criterios-zero-header-horizontal">
        <div className="alert-icon-wrapper">
          <motion.div
            className="alert-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ 
              duration: 0.5, 
              delay: 0.3,
              type: "spring",
              stiffness: 200 
            }}
          >
            <i className="fas fa-exclamation-triangle" />
          </motion.div>
        </div>        <div className="alert-content-horizontal">
          <h3 className="alert-title" id="criterios-zero-title">
            Redação Zerada
          </h3>
          <p className="alert-subtitle">
            Por conta dos critérios abaixo, sua redação foi zerada. 
            Revise cada um deles para compreender o que precisa ser melhorado:
          </p>
        </div>
      </div>      <div className="criterios-list-horizontal" aria-label="Lista de critérios que resultaram no zero da redação">
        {criteriosZero.map((criterio, index) => (
          <motion.div 
            key={criterio.id}
            className="criterio-item-horizontal"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ 
              duration: 0.3, 
              delay: 0.4 + (index * 0.1) 
            }}
          >
            <div className="criterio-card-horizontal">
              <div className="criterio-indicator" aria-hidden="true" />              <div className="criterio-content">
                <span className="criterio-name">
                  {criterio.name}
                </span>                <span className="criterio-score">
                  Critério não atendido
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>      <motion.div 
        className="encouragement-message-horizontal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.8 }}
        role="region"
        aria-label="Mensagem de encorajamento"
      >
        <i className="fas fa-lightbulb" />        <span>
          Estes critérios foram determinantes para o resultado zero da sua redação. 
          Estude cada um deles e pratique - na próxima você consegue!
        </span>
      </motion.div>
    </motion.div>
  );
}
